import { render, staticRenderFns } from "./QuestionDate.vue?vue&type=template&id=5a0f747e"
import script from "./QuestionDate.vue?vue&type=script&lang=js"
export * from "./QuestionDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports